import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import GameAbstract from './GameAbstract';
import { GameManager } from './GameManager';
import NumberUtils from 'frontools/utils/NumberUtils';

export class Assets extends AbstractDispatcher {

    public static COMPLETE  : string                    = 'complete';
    public static PROGRESS  : string                    = 'progress';
    private _progress       : number                    = 0;
    private _basePath       : string                    = '/static/public/assets/';
    public static _assets   : Object                    = {};
    public static resources : PIXI.loaders.Resource;
    public static sprites   : Object                    = {};
    private _types          : Object                    = {
        jpg: 'sprite',
        png: 'sprite',
        json: 'animated',
        mp3: 'sound'
    };
    // Howler default config
    private _howlDefaults   : Object                    = {
        preload: true
    };
    public static sounds    : Howl[]                    = [];


    
    constructor(private _config: IAssetConfig[], private _resolution: number) {
        super();

        // If the resolution is greater than one, we modify the url before preloading
        this._prepareUrls(this._config);

        let loader = PIXI.loader;
        loader.baseUrl = this._basePath;
        loader
            .add(this._config)
            .load(function(loader, resources) {
                Assets.resources = resources;
                this._preloadComplete();
            }.bind(this));
            
        // Progress event handler/dispatcher
        loader.onProgress.add(function(e) {
            this.dispatch({type: Assets.PROGRESS, progress: Math.round(e.progress)});
        }.bind(this));
    };



    /**
     * _prepareUrls - Appends retina suffix to file when the resolution has to be greater than 1
     * @param {IAssetConfig[]} config 
     * 
     */
    private _prepareUrls(config: IAssetConfig[]) {
        let gameName = GameManager.getInstance().getName();
        for (var i = 0, l = config.length; i < l; i++) {
            let asset = config[i],
                extension = this._getExtension(asset.url);

            if (!asset.core) {
                asset.url = `${gameName}/${asset.url}`;
            }

            // Retina management
            if (this._resolution > 1 && this._types[extension] !== 'sound') {
                let dotIndex = asset.url.lastIndexOf('.');
                asset.url = [asset.url.slice(0, dotIndex), `@${this._resolution}x`, asset.url.slice(dotIndex)].join('');
            }
        }
    };

    public static getRessource(name: string) {
        return Assets.resources[name];
    };

    public static getSpriteFromJson(name: string) {
        var frames = [],
            textures =  Assets.getRessource(name).textures,
            frameCount = Object.keys(textures).length;

        for (var i = 1, l = frameCount; i <= l ; i++) {
            let index = NumberUtils.leadingZero(i, 4);
            frames.push(PIXI.Texture.fromFrame(name + index + '.png'));
        }

        // create an AnimatedSprite (brings back memories from the days of Flash, right ?)
        return new PIXI.extras.AnimatedSprite(frames);
    };

    private _preloadComplete() {
        // Assets creation
        for (var i = 0, l = this._config.length; i < l; i++) {
            let asset = this._config[i] as IAssetConfig,
                extension = this._getExtension(asset.url);

            if (asset.init !== false) {
                if (this._types[extension] === 'sprite') {
                    Assets.sprites[asset.name] = new PIXI.Sprite(Assets.getRessource(asset.name).texture);
                } else if (this._types[extension] === 'animated') {
                    Assets.sprites[asset.name] = Assets.getSpriteFromJson(asset.name);
                } else if (this._types[extension] === 'sound') {
                    let options = {...this._howlDefaults, ...asset.howlConfig} as IHowlProperties;
                    options['src'] = [this._basePath + asset.url];

                    let howl = new Howl(options);
                    Assets.sounds[asset.name] = howl;
                }
            }
        }

        this.dispatch({type: Assets.COMPLETE});
    };


    private _getExtension(filename: string): string {
        return filename.substr(filename.lastIndexOf('.') + 1);
    }
    
}

export interface IAssetConfig {
    name: string;
    url: string;
    core?: boolean;
    howlConfig?: Object;
    init?: boolean;
}